import { Artist, Artists, ARTISTS } from "./Artists";

export interface Category {
  title: string;
  description?: string;
  playlists: Playlist[];
}

export interface Playlist {
  title: string;
  description: string;
  image: string;
  link?: string;
  trackList: Track[];
  color?: string;
  fake?: boolean;
}

export interface Track {
  title: string;
  artist: Artist;
  link: string;
  description?: string;
}

export const THIS_IS_GRIFFIN: Playlist = {
  title: "This is Griffin Dog",
  description:
    "This playlist is like fresh peanut butter in a kong or like solid, unbroken ice on Lake Huron. No broken tails here - this playlist is all wags.",
  image: "SpotCover_Griffin.jpg",
  color: "rgb(245, 232, 179)",
  link: "https://open.spotify.com/playlist/3iYScMd3IolbsxPQmhuajw",
  trackList: [
    {
      title: "Who Let the Dogs Out",
      artist: ARTISTS[Artists.BAHA_MEN],
      link: "https://open.spotify.com/track/1H5tvpoApNDxvxDexoaAUo",
    },
    {
      title: "Dog Days Are Over",
      artist: ARTISTS[Artists.FLORENCE],
      link: "https://open.spotify.com/track/1YLJVmuzeM2YSUkCCaTNUB",
    },
    {
      title: "Did someone say park?",
      artist: ARTISTS[Artists.GRIFFIN],
      link: "",
    },
    {
      title: "Did someone say walk?",
      artist: ARTISTS[Artists.GRIFFIN],
      link: "",
    },
    {
      title: "Did someone say dinner?",
      artist: ARTISTS[Artists.GRIFFIN],
      link: "",
    },
    {
      title: "Hungry Like the Wolf",
      artist: ARTISTS[Artists.DURAN_DURAN],
      link: "https://open.spotify.com/track/2HuHopKnnuGQEpGb0CssCs",
    },
    {
      title: "Hungry Heart",
      artist: ARTISTS[Artists.BRUCE_SPRINGSTEEN],
      link: "https://open.spotify.com/track/1KsI8NEeAna8ZIdojI3FiT",
    },
    {
      title: "Seriously, did someone say dinner?",
      artist: ARTISTS[Artists.GRIFFIN],
      link: "",
    },
  ],
};

export const THIS_IS_PETER: Playlist = {
  title: "This is Peter Scott",
  description:
    "A mashup of K-pop, heavy metal, and crippling fear that you might be alone for the rest of your life. This is the ideal playlist for the man in the $10,000 suit. This music will have you saying “What pandemic??” as you jetset away from a secure government facility to ski with your friends on the west coast.",
  image: "SpotCover_Peter.jpg",
  color: "rgb(193, 201, 217)",
  link: "https://open.spotify.com/playlist/3Dp9ucSVDzcCOjORoOzvbl",
  trackList: [
    {
      title: "Party in the U.S.A.",
      artist: ARTISTS[Artists.MILEY_CYRUS],
      link: "https://open.spotify.com/track/5Q0Nhxo0l2bP3pNjpGJwV1",
    },
    {
      title: "Empire State Of Mind",
      artist: ARTISTS[Artists.JAY_Z],
      link: "https://open.spotify.com/track/2igwFfvr1OAGX9SKDCPBwO",
    },
    {
      title: "Hopeless Wanderer",
      artist: ARTISTS[Artists.MUMFORD_AND_SONS],
      link: "https://open.spotify.com/track/7rME25EmgXGVPQqKtU4CIK",
    },
    {
      title: "Foreign Agent",
      artist: ARTISTS[Artists.PETER],
      link: "",
    },
    {
      title: "Rich Girl",
      artist: ARTISTS[Artists.HALL_AND_OATES],
      link: "https://open.spotify.com/track/0qRR9d89hIS0MHRkQ0ejxX",
    },
    {
      title: "Money Trees",
      artist: ARTISTS[Artists.KENDRICK_LAMAR],
      link: "https://open.spotify.com/track/2HbKqm4o0w5wEeEFXm2sD4",
    },
    {
      title: "Money Bags",
      artist: ARTISTS[Artists.PETER_THIEL],
      link: "",
    },
    {
      title: "Leaving, On a Jet Plane",
      artist: ARTISTS[Artists.JOHN_DENVER],
      link: "https://open.spotify.com/track/3D8dwH690MXQRhtIZTSS9c",
    },
    {
      title: "IDGAF",
      artist: ARTISTS[Artists.DUA_LIPA],
      link: "https://open.spotify.com/track/76cy1WJvNGJTj78UqeA5zr",
    },
    {
      title: "I'm Just a Kid",
      artist: ARTISTS[Artists.SIMPLE_PLAN],
      link: "https://open.spotify.com/track/6otiaV2fagE3s8IvP6WkwG",
    },
    {
      title: "There's Nothing Holdin' Me Back",
      artist: ARTISTS[Artists.SHAWN_MENDES],
      link: "https://open.spotify.com/track/7JJmb5XwzOO8jgpou264Ml",
    },
    {
      title: "Livin' la Vida Loca",
      artist: ARTISTS[Artists.RICKY_MARTIN],
      link: "https://open.spotify.com/track/0Ph6L4l8dYUuXFmb71Ajnd",
    },
    {
      title: "Surfin' U.S.A.",
      artist: ARTISTS[Artists.BEACH_BOYS],
      link: "https://open.spotify.com/track/2EPr9Wx7e1cpGEbNAtuN7x",
    },
    {
      title: "Billionaire",
      artist: ARTISTS[Artists.TRAVIE_MCCOY],
      link: "https://open.spotify.com/track/2M9ULmQwTaTGmAdXaXpfz5",
    },
  ],
};

export const THIS_IS_ANNA: Playlist = {
  title: "This is Anna Scott",
  description:
    "A powerful, sassy playlist perfect for any current or former CEO. The ideal soundtrack for selling out. These ballads will move you from triumph, to tears, to a giggly-baby voiced mood saying “Yaaaan.”",
  image: "SpotCover_Anna.jpg",
  color: "rgb(171, 222, 212)",
  link: "https://open.spotify.com/playlist/5lEXBcqzkEWYkaC2krNIxr",
  trackList: [
    {
      title: "Respect",
      artist: ARTISTS[Artists.ARETHA_FRANKLIN],
      link: "https://open.spotify.com/track/7s25THrKz86DM225dOYwnr",
    },
    {
      title: "Sell Out",
      artist: ARTISTS[Artists.REEL_BIG_FISH],
      link: "https://open.spotify.com/track/6SJ1hWFVBIiUgGgHKvwXCQ",
    },
    {
      title: "Big Oil",
      artist: ARTISTS[Artists.TROPOSPHERE_MONITORING],
      link: "",
    },
    {
      title: "Parlez-vous Anglais?",
      artist: ARTISTS[Artists.ANNA],
      link: "",
    },
    {
      title: "If I Were a Boy",
      artist: ARTISTS[Artists.BEYONCE],
      link: "https://open.spotify.com/track/26NX1wPt1TRCH536yocd6i",
    },
    {
      title: "Unfinished Business",
      artist: ARTISTS[Artists.MUMFORD_AND_SONS],
      link: "https://open.spotify.com/track/0Dta2GzHUGQbARAKnQrWDk",
    },
    {
      title: "Just Got Paid",
      artist: ARTISTS[Artists.SIGALA],
      link: "https://open.spotify.com/track/0v3BMLcwUmAwyqJaf5997o",
    },
    {
      title: "Honey, I'm Good.",
      artist: ARTISTS[Artists.ANDY_GRAMMER],
      link: "https://open.spotify.com/track/4MflGTO2ZTcSQ12bWcyRgI",
    },
    {
      title: "What a Girl Wants",
      artist: ARTISTS[Artists.CHRISTINA_AGUILERA],
      link: "https://open.spotify.com/track/5bGmuxShUba9maPswDnhCs",
    },
    {
      title: "C'est La Vie",
      artist: ARTISTS[Artists.B_WITCHED],
      link: "https://open.spotify.com/track/0P6CPJrNJ1Zt755CQTWg3S",
    },
  ],
};

export const THIS_IS_RIDG: Playlist = {
  title: "This is Ridg Scott",
  description:
    "A generic mashup of Beach Boys and Alvin and the Chipmunks Christmas hits, ideal for any older white retirees getting driven by their Toyota Rav4s. No need to focus on the road - set your follow distance to medium and sing along to these jams!",
  image: "SpotCover_Ridg.jpg",
  color: "rgb(179, 210, 232)",
  link: "https://open.spotify.com/playlist/7qmiwWztndTQb0XGvWhFZv",
  trackList: [
    {
      title: "Two Edged Sword",
      artist: ARTISTS[Artists.DONALD_TRUMP],
      link: "",
    },
    {
      title: "It's Five O'Clock Somewhere",
      artist: ARTISTS[Artists.ALAN_JACKSON],
      link: "https://open.spotify.com/track/5oHHMDcVOmPSFrCgdbHPdb",
    },
    {
      title: "This Watch Tells History",
      artist: ARTISTS[Artists.RIDG],
      link: "",
    },
    {
      title: "Whiskey Glasses",
      artist: ARTISTS[Artists.MORGAN_WALLEN],
      link: "https://open.spotify.com/track/6foY66mWZN0pSRjZ408c00",
    },
    {
      title: "Beer For My Horses",
      artist: ARTISTS[Artists.TOBY_KEITH],
      link: "https://open.spotify.com/track/7E2DqvnVtbIrFrL5X6YH9Q",
    },
    {
      title: "Buy Me a Boat",
      artist: ARTISTS[Artists.CHRIS_JANSON],
      link: "https://open.spotify.com/track/2WKLUgklz0VDX5bKTZ3eYD",
    },
    {
      title: "Pretty Fly (For A White Guy)",
      artist: ARTISTS[Artists.THE_OFFSPRING],
      link: "https://open.spotify.com/track/3SFXsFpeGmBTtQvKiwYMDA",
    },
    {
      title: "Sail",
      artist: ARTISTS[Artists.AWOLNATION],
      link: "https://open.spotify.com/track/5xhQChGGhKLWqBqX4XhtYE",
    },
    {
      title: "Come Sail Away",
      artist: ARTISTS[Artists.STYX],
      link: "https://open.spotify.com/track/0PsbWiVtix5FoTZ1s00mEl",
    },
    {
      title: "A Hard Day's Night",
      artist: ARTISTS[Artists.THE_BEATLES],
      link: "https://open.spotify.com/track/5J2CHimS7dWYMImCHkEFaJ",
    },
    {
      title: "If You've Got The Money, I've Got the Time",
      artist: ARTISTS[Artists.WILLIEN_NELSON],
      link: "https://open.spotify.com/track/7aVapcvsbFYYmcQvhkc8Rc",
    },
    {
      title: "(Sittin' On) the Dock of the Bay",
      artist: ARTISTS[Artists.OTIS_REDDING],
      link: "https://open.spotify.com/track/3zBhihYUHBmGd2bcQIobrF",
    },
  ],
};

export const THIS_IS_YAN: Playlist = {
  title: "This is Yan Azdoud",
  description:
    "The high-powered hits don’t stop in this country music meets cooking show playlist. Whether you’re driving a rented F150 down highways in Texas, or getting that hot new tattoo from your local vending machine - this playlist will butter your biscuit. And all of your other food.",
  image: "SpotCover_Yan.jpg",
  color: "rgb(183, 231, 247)",
  link: "https://open.spotify.com/playlist/6QdGqmwwsu8mMFtKCozNPA",
  trackList: [
    {
      title: "Hips Don't Lie",
      artist: ARTISTS[Artists.SHAKIRA],
      link: "https://open.spotify.com/track/3ZFTkvIE7kyPt6Nu3PEa7V",
    },
    {
      title: "Body Like A Back Road",
      artist: ARTISTS[Artists.SAM_HUNT],
      link: "https://open.spotify.com/track/7mldq42yDuxiUNn08nvzHO",
    },
    {
      title: "Morocco",
      artist: ARTISTS[Artists.MOON_TAXI],
      link: "https://open.spotify.com/track/0ecM7uGyjgJnBliXS2fPP9",
    },
    {
      title: "Gimme the Butter Baby",
      artist: ARTISTS[Artists.ANNA],
      link: "",
    },
    {
      title: "Drive My Car",
      artist: ARTISTS[Artists.THE_BEATLES],
      link: "https://open.spotify.com/track/06ypiqmILMdVeaiErMFA91",
    },
    {
      title: "Take Me Home, Country Roads",
      artist: ARTISTS[Artists.JOHN_DENVER],
      link: "https://open.spotify.com/track/39q7xibBdRboeMKUbZEB6g",
    },
    {
      title: "Love Is Blind",
      artist: ARTISTS[Artists.COLEMAN_HELL],
      link: "https://open.spotify.com/track/4qk35C5lGrStA7N8XiExHt",
    },
    {
      title: "Don't Take The Money",
      artist: ARTISTS[Artists.BLEACHERS],
      link: "https://open.spotify.com/track/3ySU5vwQB33iGulwcUL9qQ",
    },
    {
      title: "Road Trippin'",
      artist: ARTISTS[Artists.DAN_AND_SHAY],
      link: "https://open.spotify.com/track/2IOvJJrN6RajoMOd9TyGra",
    },
    {
      title: "Heavy Bones",
      artist: ARTISTS[Artists.ARIEL_FERNANDEZ],
      link: "",
    },
    {
      title: "My Chick Bad",
      artist: ARTISTS[Artists.LUDACRIS],
      link: "https://open.spotify.com/track/3bMNprrp2JDKZsGbiXpsJl",
    },
  ],
};

export const THIS_IS_JORDAN: Playlist = {
  title: "This is Jordan O`Neill",
  description:
    "Backstreet Boys meets dad bod in this party-mix playlist. Crank the volume up and you won’t even notice the disc-golf chains clanging in the backyard as you sing along. Whether it’s your once-weekly 30-minute meeting, or trying to master that perfect man-bun, blast these bops to get you through those stressful moments in your life.",
  image: "SpotCover_Jordan.jpg",
  color: "rgb(240, 229, 170)",
  link: "https://open.spotify.com/playlist/15F6BTWx2I3TEU6BK5v1sI",
  trackList: [
    {
      title: "Work from Home",
      artist: ARTISTS[Artists.FIFTH_HARMONY],
      link: "https://open.spotify.com/track/4tCtwWceOPWzenK2HAIJSb",
    },
    {
      title: "How Do You Sleep?",
      artist: ARTISTS[Artists.SAM_SMITH],
      link: "https://open.spotify.com/track/6b2RcmUt1g9N9mQ3CbjX2Y",
    },
    {
      title: "Shut Up and Dance",
      artist: ARTISTS[Artists.WALK_THE_MOON],
      link: "https://open.spotify.com/track/4kbj5MwxO1bq9wjT5g9HaA",
    },
    {
      title: "Long Hair Don't Care",
      artist: ARTISTS[Artists.JORDAN],
      link: "",
    },
    {
      title: "She Hates Me",
      artist: ARTISTS[Artists.PUDDLE_OF_MUDD],
      link: "https://open.spotify.com/track/16DhvbuyvJob4Q9GHNYu2n",
    },
    {
      title: "Sit Still, Look Pretty",
      artist: ARTISTS[Artists.DAYA],
      link: "https://open.spotify.com/track/0EGuSSpuu9wmHCtvb4PdLO",
    },
    {
      title: "Crazy for This Girl",
      artist: ARTISTS[Artists.EVAN_AND_JARON],
      link: "https://open.spotify.com/track/2gdt70w8DOCWGq1HdkgSUd",
    },
    {
      title: "Disc Golf Podcast",
      artist: ARTISTS[Artists.DISC_GOLFERS],
      link: "",
    },
    {
      title: "Girls Just Want to Have Fun",
      artist: ARTISTS[Artists.CYNDI_LAUPER],
      link: "https://open.spotify.com/track/4y1LsJpmMti1PfRQV9AWWe",
    },
    {
      title: "Wake Me Up Before You Go-Go",
      artist: ARTISTS[Artists.WHAM],
      link: "https://open.spotify.com/track/0ikz6tENMONtK6qGkOrU3c",
    },
    {
      title: "Dancing Queen",
      artist: ARTISTS[Artists.ABBA],
      link: "https://open.spotify.com/track/0GjEhVFGZW8afUYGChu3Rr",
    },
  ],
};

export const THIS_IS_SARA: Playlist = {
  title: "This is Sara Scott",
  description:
    "For those of you that do not understand the meaning of relaxation--this productivity-enhancing playlist uniquely allows you to play songs at 1.75x speed. Have 4 free minutes between activities? Try to bake a cake! Don't even worry about cleaning those dishes!",
  image: "SpotCover_Sara.jpg",
  color: "rgb(155, 201, 161)",
  link: "https://open.spotify.com/playlist/15F6BTWx2I3TEU6BK5v1sI",
  trackList: [
    {
      title: "You Need To Calm Down",
      artist: ARTISTS[Artists.TAYLOR_SWIFT],
      link: "https://open.spotify.com/track/6RRNNciQGZEXnqk8SQ9yv5",
    },
    {
      title: "Is this a business expense?",
      artist: ARTISTS[Artists.SARA],
      link: "",
    },
    {
      title: "The 3 R's",
      artist: ARTISTS[Artists.JACK_JOHNSON],
      link: "https://open.spotify.com/track/1v6WwQtShGnXe5Fc0xyjHO",
    },
    {
      title: "That Don't Impress Me Much",
      artist: ARTISTS[Artists.SHANIA_TWAIN],
      link: "https://open.spotify.com/track/4FUfoWMypAyWbOavmYyeNu",
    },
    {
      title: "How to Save a Life",
      artist: ARTISTS[Artists.THE_FRAY],
      link: "https://open.spotify.com/track/5fVZC9GiM4e8vu99W0Xf6J",
    },
    {
      title: "I Want It That Way",
      artist: ARTISTS[Artists.BACKSTREET_BOYS],
      link: "https://open.spotify.com/track/47BBI51FKFwOMlIiX6m8ya",
    },
    {
      title: "Gives You Hell",
      artist: ARTISTS[Artists.ALL_AMERICAN_REJECTS],
      link: "https://open.spotify.com/track/6ihL9TjfRjadfEePzXXyVF",
    },
    {
      title: "Hero",
      artist: ARTISTS[Artists.ENRIQUE_IGLESIAS],
      link: "https://open.spotify.com/track/24Gxm7Eh7tO83E26LG0CsY",
    },
    {
      title: "Every Little Thing She Does Is Magic",
      artist: ARTISTS[Artists.THE_POLICE],
      link: "https://open.spotify.com/track/44aTAUBF0g6sMkMNE8I5kd",
    },
    {
      title: "Sweet Disposition",
      artist: ARTISTS[Artists.THE_TEMPER_TRAP],
      link: "https://open.spotify.com/track/5RoIXwyTCdyUjpMMkk4uPd",
    },
    {
      title: "All I Do Is Win",
      artist: ARTISTS[Artists.DJ_KHALED],
      link: "https://open.spotify.com/track/75FT1IPlCYCs5DAYbR9mjE",
    },
  ],
};

export const YEAR_IN_REVIEW: Playlist = {
  title: "Year In Review",
  description: "",
  image: "YearInReview.png",
  color: "rgb(155, 201, 161)",
  trackList: [],
  fake: true,
};

export const HAMILTON: Playlist = {
  title: "Hamilton",
  description: "",
  image: "Hamilton.jpg",
  color: "rgb(155, 201, 161)",
  link: "https://open.spotify.com/album/1kCHru7uhxBUdzkm4gzRQc?si=QSlhXt06RTWaCXqjNV2i7w",
  trackList: [],
  fake: true,
};

export const EVAN_HANSEN: Playlist = {
  title: "Dear Evan Hansen",
  description: "",
  image: "EvanHansen.jpg",
  color: "rgb(155, 201, 161)",
  link: "https://open.spotify.com/album/0LhDyJXelg31FKLW5GDcKi?si=GkGjGr9_S3SzmAjxx-k8wQ",
  trackList: [],
  fake: true,
};

export const WILLIE_NELSON_PLAYLIST: Playlist = {
  title: "This is Willie Nelson",
  description: "",
  image: "WillieNelson.jpg",
  color: "rgb(155, 201, 161)",
  link: "https://open.spotify.com/playlist/37i9dQZF1DWWIjhBGHJI0J",
  trackList: [],
  fake: true,
};

export const BEACH_BOYS: Playlist = {
  title: "This is Beach Boys",
  description: "",
  image: "BeachBoys.jpg",
  color: "rgb(155, 201, 161)",
  link: "https://open.spotify.com/playlist/37i9dQZF1DXaZan2kzvaVc",
  trackList: [],
  fake: true,
};

export const SAD_SONGS: Playlist = {
  title: "Sad Songs",
  description: "",
  image: "SadSongs.jpg",
  color: "rgb(155, 201, 161)",
  link: "https://open.spotify.com/playlist/7ABD15iASBIpPP5uJ5awvq",
  trackList: [],
  fake: true,
};

export const PODCAST_JAN: Playlist = {
  title: "Boring History for Sleep",
  description:
    "After her dream of an audio-only bird-watching podcast failed, Jan pivoted to a new genre: taking you on a play-by-play of her most recent literary finds. Each episode features riveting topics such as the love life of Gutenberg’s apprentice’s apprentice or a shockingly depressing novel about a spiteful mother with an alcohol problem (spoiler alert - almost all of her children die). A must subscribe for those having trouble falling asleep, people who enjoy sadness as background noise, or those that simply need a reminder that everything could always be worse.",
  image: "SpotifyCover_Jan.png",
  color: "rgb(119, 57, 66)",
  trackList: [
    {
      title: "Is This Thing On?",
      artist: ARTISTS[Artists.JAN],
      link: "",
      description:
        "An hour of Jan trying to figure out how to click on this link",
    },
    {
      title: "No, Seriously… How Does This Work?",
      artist: ARTISTS[Artists.JAN],
      link: "https://open.spotify.com/track/3lec3CzDPAxsZokPph5w87",
      description:
        "Sixty straight minutes of Jan calling Jordan for tech support.",
    },
  ],
};

export const PODCAST_RIDG: Playlist = {
  title: "How I Built This with Ridgway Scott",
  description:
    "In this series of stirring, intimate interviews, avid bird-picture re-photographer Ridgway Scott reflects on his journey from simple cottager to general contractor. In this long-awaited tell-all, Ridgway walks friends and family through the story of how the Cedarville addition evolved into a six-year odyssey. For anyone who has ever wondered “Seriously, how is this thing not finished?” this is a must-listen.",
  image: "SpotifyCover_Ridg.png",
  color: "rgb(63, 63, 63)",
  trackList: [
    {
      title: "Construction Basics with Ridg",
      artist: ARTISTS[Artists.RIDG],
      link: "",
      description: "Overcomplicating the uncomplicated.",
    },
    {
      title: "Very Carefully",
      artist: ARTISTS[Artists.RIDG],
      link: "",
      description: "That’s it. That’s the whole episode.",
    },
    {
      title: "The Bonus Bedroom",
      artist: ARTISTS[Artists.RIDG],
      link: "",
      description:
        "How the Scotts were somehow surprised by the existence of an entire extra floor, despite working with both an architect and a contractor.",
    },
  ],
};

export const PODCAST_ANNA: Playlist = {
  title: "Diary of a CEO with Anna Scott",
  description:
    "Step inside the mind of Anna Scott, the CEO so daring she blew up her only prototype to make waves. She joins the podcast space to give a long overdue voice to big mining (and also to garner some desperately needed advertising revenue). You may think you know her story, but now you’ll hear the truth about what inspired her journey to Rock Bottom. Subscribe for all the steamy and sordid details of her mysterious career.",
  image: "SpotifyCover_Anna.png",
  color: "rgb(128,77,47)",
  trackList: [
    {
      title: "Out of the Fish Tank and Into the Fishbowl",
      artist: ARTISTS[Artists.ANNA],
      link: "",
      description:
        "A behind-the-scenes look at her exclusive, millionaires-only Texas oil-influencer book club.",
    },
    {
      title: "Unlocking From the Inside",
      artist: ARTISTS[Artists.ANNA],
      link: "",
      description:
        "A practical guide to teaching your child how to free themselves after locking themselves in the car.",
    },
    {
      title: "Keeping Your Used Running Shoes Pristine",
      artist: ARTISTS[Artists.ANNA],
      link: "",
      description: "TL;DR: Don’t use them.",
    },
  ],
};

export const PODCAST_YAN: Playlist = {
  title: "Armchair Expert with Yan Azdoud",
  description:
    "Join Yan Azdoud on hourslong phone calls as he leaves his physical armchair (but not his metaphorical one) to pace the house while monologuing about wide-ranging topics. Celebrated as the podcast that answers questions you didn’t even ask, each episode will leave you confused, slightly anxious, but routinely coming back for more. The perfect podcast for listeners who enjoy debates where both participants are Yan.",
  image: "SpotifyCover_Yan.png",
  color: "rgb(43, 47, 53)",
  trackList: [
    {
      title: "Thwarted by Mediocrity",
      artist: ARTISTS[Artists.YAN],
      link: "",
      description: "A step-by-step guide to company takeover",
    },
    {
      title: "Knife skills 101",
      artist: ARTISTS[Artists.YAN],
      link: "",
      description:
        "On shaving a Serrano Ham from Costco and why you actually don’t need the tip of your finger",
    },
  ],
};

export const PODCAST_PETER: Playlist = {
  title: "Pardon my Take",
  description:
    "After flaming out of a Michelin-starred kitchen, Peter Scott embarked on a three month journey on the Pacific Crest Trail to enhance his tightly clung-to sense of personal superiority. Three months of time alone with just his thoughts and his spindly facial hair helped marinate some truly inflammatory takes. Now, the uncredited co-author of “Are women ruining the workplace?” joins the podcast space, ready to unapologetically take on controversial opinions. ",
  image: "SpotifyCover_Peter.png",
  color: "rgb(55,55,55)",
  trackList: [
    {
      title: "The Art of Interior Design",
      artist: ARTISTS[Artists.PETER],
      link: "",
      description:
        "Peter dives deep into what actually qualifies as “art” and makes a passionate case for miniature furniture.",
    },
    {
      title: "Winning cookoffs",
      artist: ARTISTS[Artists.PETER],
      link: "",
      description:
        "A deep dive into why it’s absolutely fine to stuff the ballot for a friendly home cook competition",
    },
    {
      title: "I’m totally fine going grey at 30",
      artist: ARTISTS[Artists.PETER],
      link: "",
      description:
        "A thinly veiled cry for help coupled with an explanation of his ankle sounds",
    },
  ],
};

export const PODCAST_WINN: Playlist = {
  title: "Cereal",
  description:
    "This is Cereal - the story of one toddler, one incredibly broad definition of a gateau, and one Spanish-speaking Japanese train. Stay tuned as they embark on their mission... or maybe absolutely refuse to.",
  image: "SpotifyCover_WinnTwo.png",
  color: "rgb(158,35,29)",
  trackList: [
    {
      title: "Shark attack",
      artist: ARTISTS[Artists.WINN],
      link: "",
      description: "",
    },
    {
      title: "Jordan is a dump truck",
      artist: ARTISTS[Artists.WINN],
      link: "",
      description: "",
    },
  ],
};

export const PODCAST_GRIFFIN: Playlist = {
  title: "Soft White Underbelly",
  description:
    "Sometimes he’s up, sometimes he’s down, but he’s always soft — and usually napping.",
  image: "SpotifyCover_Griffin.png",
  color: "rgb(78,78,78)",
  trackList: [
    {
      title: "Breakfast",
      artist: ARTISTS[Artists.GRIFFIN],
      link: "",
      description: "",
    },
    {
      title: "Dinner",
      artist: ARTISTS[Artists.GRIFFIN],
      link: "",
      description: "",
    },
    {
      title: "Whatever happened to lunch?",
      artist: ARTISTS[Artists.GRIFFIN],
      link: "",
      description: "",
    },
  ],
};

export const PODCAST_NUTMEG: Playlist = {
  title: "Call her Daddy",
  description:
    "From the most badass bitch around comes the most-listened to podcast by women. From deep, honest discussions to laugh-out-loud moments, Nutmeg cuts through the BS with exciting guests and bold topics.",
  image: "SpotifyCover_Nutmeg.png",
  color: "rgb(255,101,177)",
  trackList: [
    {
      title: "The Princess and the Pea",
      artist: ARTISTS[Artists.NUTMEG],
      link: "",
      description:
        "Unlocking the secret to finding (and claiming) the softest spot in the entire house",
    },
    {
      title: "Hunger Strike",
      artist: ARTISTS[Artists.NUTMEG],
      link: "",
      description:
        "A strategic guide to refusing dog food until the humans give you their food",
    },
  ],
};

export const PODCAST_TOTS: Playlist = {
  title: "Reality Escape Pod",
  description:
    "After meeting her lifelong heroes and favorite soccer podcast hosts and finally admitting outloud their podcast actually isn’t very good, tots “Becky Moore” decides it’s time to enter into the podcasting arena herself. Boda Borg’s speediest, stealthiest competitor brings an entirely unnecessary level of athleticism to an incredibly niche genre, adding a new dimension to an underappreciated — and frankly unnecessary — corner of the podcasting market. This show is perfect for anyone who craves overly granular analysis delivered by a globe-trotting escape artist and self-proclaimed witty commentator.",
  image: "SpotifyCover_Tots.png",
  color: "rgb(20,193,238)",
  trackList: [
    {
      title: "Disappointment in Ireland",
      artist: ARTISTS[Artists.TOTS],
      link: "",
      description: "Why I bought Boda Borg International.",
    },
    {
      title: "Clickbait",
      artist: ARTISTS[Artists.TOTS],
      link: "",
      description:
        "“What do you mean I’m not normal?” A sincere exploration of wearing mittens in bed ",
    },
  ],
};

export const PODCAST_TAMMY: Playlist = {
  title: "Up First from NPR",
  description: `Award-winning Scott-family neighbor and Winn Scott-Azdoud’s closest confidante steps into the podcasting arena to reveal what it’s truly like to arrive in Cedarville before everyone else and how lonely it can be to be “Up First” without the Scotts. As the reigning social chair, she offers exclusive updates on Chewy’s upcoming birthday party and essential intel on the social happenings of the summer.`,
  image: "SpotifyCover_TammyTwo.png",
  color: "rgb(32,75,89)",
  trackList: [
    {
      title: "Euchre Champions",
      artist: ARTISTS[Artists.TAMMY],
      link: "",
      description:
        "A play-by-play of the stunning, come-from-behind defeat of Ridgway Scott and Jordan O’Neill",
    },
    {
      title: "Planting Trees",
      artist: ARTISTS[Artists.TAMMY],
      link: "",
      description:
        "A thoughtful analysis of the exact moment when a neighbor officially becomes too close",
    },
  ],
};

export const PODCAST_AMY: Playlist = {
  title: "The Runna Podcast",
  description:
    "Newly self-identified runner and PR-chaser Amy Nesky eagerly enters the podcast space to share the thoughts that don’t always get the enthusiastic reception she expects when texted into groups. Whether or not you will learn much about running is unclear. But rest assured, you’ll learn something.",
  image: "SpotifyCover_Amy.png",
  color: "rgb(173,78,64)",
  trackList: [
    {
      title: "Words of the day:",
      artist: ARTISTS[Artists.AMY],
      link: "",
      description:
        "an unnecessarily long list of interesting vocabulary words I’ve been stockpiling",
    },
    {
      title: "LCI Drone Footage",
      artist: ARTISTS[Artists.AMY],
      link: "",
      description: "a love letter",
    },
  ],
};

export const PODCAST_JORDAN: Playlist = {
  title: "Jordan O’Neill Needs a Friend",
  description:
    "After designing and completing a beautiful, lavishly gold-accented, home in the Ohio countryside, Jordan O’Neill can’t shake the feeling that someone else should be living there too. After attempting to fill the void with a brief stint delivering food along the Pacific Crest Trail, attempting to cultivate a British accent through immersion in the Premier League, and meticulous photodocumentation of his dog’s bowel movements, he turns to podcasting as a way to fill the (gold-trimmed) space. This podcast is perfect for anyone who lives alone but still craves a steady stream of positive affirmation.",
  image: "SpotifyCover_Jordan.png",
  color: "rgb(206,108,41)",
  trackList: [
    {
      title: "Mini-splits",
      artist: ARTISTS[Artists.JORDAN],
      link: "",
      description: "an emotional tribute to a beautiful device",
    },
    {
      title: "Sara’s job prospects ",
      artist: ARTISTS[Artists.JORDAN],
      link: "",
      description:
        "A reflective look at what turned out to be a questionable investment.",
    },
  ],
};

export const PODCAST_SARA: Playlist = {
  title: "Hidden Brain",
  description: `After reading the sci-fi thriller Upgrade, Sara realized it wasn’t fiction - it was a biography. Now, she invites listeners to tour the "Hidden Brain" living inside her regular brain, a turbocharged cognitive center that allows her to be mentally superior.`,
  image: "SpotifyCover_Sara.png",
  color: "rgb(30, 47, 92)",
  trackList: [
    {
      title: "How to Act Normal",
      artist: ARTISTS[Artists.SARA],
      link: "",
      description:
        "A survival guide on how to interact with non-upgraded humans (friends and family) without letting on that you view them as slow-moving hindrances all while remembering to blink.",
    },
    {
      title: "The 4 Hour Workweek",
      artist: ARTISTS[Artists.SARA],
      link: "",
      description:
        "Sara breaks down the math on how to compress three full days of output into a tight four-hour window, leaving the rest of the week open for getting through multiple-page to-do lists.",
    },
    {
      title: "Inch Perfect",
      artist: ARTISTS[Artists.SARA],
      link: "",
      description:
        "Why your current route through Trader Joe's is mathematically unsound and adds seven unnecessary minutes to your trip.",
    },
    {
      title: "Optimizing the Meat Vehicle",
      artist: ARTISTS[Artists.SARA],
      link: "",
      description:
        "A daily running guide from a self-proclaimed non-runner. Not for health, but to ensure the physical hardware can finally keep up with the upgraded software.",
    },
    {
      title: "Yes, please tell me what ChatGPT told you.",
      artist: ARTISTS[Artists.SARA],
      link: "",
      description:
        "Sara explains the agony of listening to her husband explain his symptoms while she knew it was likely gas pain before he even started the conversation.",
    },
  ],
};

// export const PODCAST_: Playlist = {
//   title: "",
//   description: "",
//   image: "SpotCover_Jan.jpg",
//   color: "rgb(193, 183, 235)",
//   trackList: [
//     {
//       title: "",
//       artist: ARTISTS[Artists.],
//       link: "",
//       description:
//         "",
//     },
//     {
//       title: "",
//       artist: ARTISTS[Artists.],
//       link: "",
//       description:
//         "",
//     },
//   ],
// };

export const PLAYLISTS: Playlist[] = [
  PODCAST_JAN,
  PODCAST_RIDG,
  PODCAST_SARA,
  PODCAST_JORDAN,
  PODCAST_ANNA,
  PODCAST_YAN,
  PODCAST_PETER,
  PODCAST_GRIFFIN,
  PODCAST_NUTMEG,
  PODCAST_WINN,
  PODCAST_TOTS,
  PODCAST_AMY,
  PODCAST_TAMMY,
];

export const YEAR_IN_PODCASTS: Category = {
  title: "2025 in Podcasts",
  playlists: [PODCAST_RIDG, PODCAST_YAN, PODCAST_PETER, PODCAST_TOTS],
};

export const BINGE_WORTHY_SHOWS: Category = {
  title: "Binge-Worthy Shows",
  playlists: [PODCAST_JAN, PODCAST_ANNA, PODCAST_JORDAN],
};

export const EPISODES_NO_MISS: Category = {
  title: "Episodes You Won't Want to Miss",
  playlists: [PODCAST_SARA, PODCAST_GRIFFIN, PODCAST_NUTMEG],
};

export const MORE_OF_WHAT_YOU_LIKE: Category = {
  title: "More of What You Like",
  playlists: [PODCAST_AMY, PODCAST_TAMMY, PODCAST_WINN],
};

// export const HEAVY_ROTATION: Category = {
//   title: "Your heavy rotation",
//   playlists: [PODCAST_ANNA, PODCAST_YAN, PODCAST_JORDAN],
// };

// export const FRESH_NEW_MUSIC: Category = {
//   title: "Fresh new music",
//   playlists: [PODCAST_TAMMY, PODCAST_AMY, PODCAST_TOTS],
// };

export const YEARS_IN_REWIND: Category = {
  title: "Year in review",
  playlists: [YEAR_IN_REVIEW],
};

// export const MORE_OF_WHAT_YOU_LIKE: Category = {
//   title: "More of what you like",
//   playlists: [PODCAST_GRIFFIN, PODCAST_NUTMEG, PODCAST_WINN],
// };

// export const OLDIES_BUT_GOODIES: Category = {
//   title: "Oldies but goodies",
//   playlists: [PODCAST_JAN, PODCAST_RIDG],
// };
// export const CHRISTMAS_CLASSICS: Category = {
//   title: "Christmas classics",
//   playlists: [PODCAST_ANNA, PODCAST_PETER],
// };
// export const RECENTLY_PLAYED: Category = {
//   title: "Recently played",
//   playlists: [
//     HAMILTON,
//     BEACH_BOYS,
//     EVAN_HANSEN,
//     WILLIE_NELSON_PLAYLIST,
//     SAD_SONGS,
//   ],
// };

export const CATEGORIES: Category[] = [
  YEAR_IN_PODCASTS,
  BINGE_WORTHY_SHOWS,
  EPISODES_NO_MISS,
  MORE_OF_WHAT_YOU_LIKE,
  YEARS_IN_REWIND,
];
